import { HttpClient } from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SupplierInvoicesService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Définit les headers utilisés par le service.
     *
     * Les headers sont normalement alimentés
     * lors de l'identification de l'utilisateur.
     */
    setHeaders(_headers) {
        this.httpHeaders = _headers;
    }
    /**
     * Recherche des factures fournisseurs.
     *
     * POST :
     *
     * /wks/api/supplierinvoices/search
     */
    search(_entity, _criteria) {
        const urlCur = `${environment.baseUrl}/wks/api/supplierinvoices/search`;
        const body = JSON.stringify(_criteria);
        const localHttpHeaders = this.httpHeaders
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('stdEntity', _entity);
        return this.httpClient
            .post(urlCur, body, {
            headers: localHttpHeaders,
            observe: 'response'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Récupération des fournisseurs.
     *
     * POST :
     *
     * /wks/api/supplierinvoices/suppliers
     */
    getSuppliers(_entity) {
        const urlCur = `${environment.baseUrl}/wks/api/suppliers`;
        const localHttpHeaders = this.httpHeaders
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('stdEntity', _entity);
        return this.httpClient
            .post(urlCur, null, {
            headers: localHttpHeaders,
            observe: 'response'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Récupération d'une facture fournisseur.
     *
     * GET :
     *
     * /wks/api/supplierinvoices/{id}
     */
    getInvoice(_id) {
        const urlCur = `${environment.baseUrl}/wks/api/supplierinvoices/${_id}`;
        const localHttpHeaders = this.httpHeaders
            .set('Accept', 'application/json');
        return this.httpClient
            .get(urlCur, {
            headers: localHttpHeaders,
            observe: 'response'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Récupération du PDF d'une facture fournisseur.
     *
     * GET :
     *
     * /wks/api/supplierinvoices/{id}/pdf
     *
     * La réponse est retournée sous forme de Blob.
     */
    getPdf(_ref, _entity) {
        const urlCur = `${environment.baseUrl}/wks/api/supplierinvoices/pdf`;
        const body = {
            ref: _ref
        };
        const localHttpHeaders = this.httpHeaders
            .set('Accept', '*/*')
            .set('stdEntity', _entity);
        return this.httpClient
            .post(urlCur, body, {
            headers: localHttpHeaders,
            observe: 'response',
            responseType: 'blob'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Mise à jour du statut d'une facture fournisseur.
     *
     * PUT :
     *
     * /wks/api/supplierinvoices/{id}/status
     */
    updateStatus(_id, _status, _entity) {
        const urlCur = `${environment.baseUrl}/wks/api/supplierinvoices/status`;
        const body = {
            id: _id,
            status: Number(_status),
        };
        const localHttpHeaders = this.httpHeaders
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('stdEntity', _entity);
        return this.httpClient
            .post(urlCur, body, {
            headers: localHttpHeaders,
            observe: 'response'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Récupération du tracking d'une facture.
     *
     * GET :
     *
     * /wks/api/supplierinvoices/tracking/{id}
     */
    getTracking(_entity, _invoiceId) {
        const urlCur = `${environment.baseUrl}/wks/api/supplierinvoices/tracking`;
        const body = JSON.stringify({
            invoiceId: String(_invoiceId)
        });
        const localHttpHeaders = this.httpHeaders
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('stdEntity', _entity);
        return this.httpClient
            .post(urlCur, body, {
            headers: localHttpHeaders,
            observe: 'response'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Récupération des événements du tracking.
     *
     * GET :
     *
     * /wks/api/supplierinvoices/tracking/{trackingId}/events
     */
    getTrackingEvents(_entity, _invoiceId) {
        const urlCur = `${environment.baseUrl}/wks/api/supplierinvoices/tracking-events`;
        const body = {
            invoiceId: _invoiceId
        };
        const localHttpHeaders = this.httpHeaders
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('stdEntity', _entity);
        return this.httpClient
            .post(urlCur, body, {
            headers: localHttpHeaders,
            observe: 'response'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Gestion des erreurs HTTP.
     */
    handleErrorObservable(error) {
        return observableThrowError(error);
    }
    updateTrackingStatus(entity, invoiceId, trackingStatus, documentType, reasonCode, reason) {
        const urlCur = `${environment.baseUrl}/wks/api/supplierinvoices/tracking-status`;
        const body = {
            invoiceId: String(invoiceId),
            trackingStatus: trackingStatus,
            documentType: documentType,
            reasonCode: reasonCode,
            reason: reason
        };
        const localHttpHeaders = this.httpHeaders
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('stdEntity', entity);
        return this.httpClient
            .post(urlCur, JSON.stringify(body), {
            headers: localHttpHeaders,
            observe: 'response'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Impression de plusieurs factures fournisseurs.
     *
     * POST :
     *
     * /wks/api/supplierinvoices/print
     */
    printSuppiersInvoices(_invoiceIds, _entity) {
        const urlCur = `${environment.baseUrl}/wks/api/supplierinvoices/printSuppiersInvoices`;
        const body = {
            invoiceIds: _invoiceIds
        };
        const localHttpHeaders = this.httpHeaders
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/pdf')
            .set('stdEntity', _entity);
        return this.httpClient
            .post(urlCur, body, {
            headers: localHttpHeaders,
            observe: 'response',
            responseType: 'blob'
        })
            .pipe(catchError(this.handleErrorObservable));
    }
}
SupplierInvoicesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SupplierInvoicesService_Factory() { return new SupplierInvoicesService(i0.ɵɵinject(i1.HttpClient)); }, token: SupplierInvoicesService, providedIn: "root" });
